
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface NetworkStatsData {
  totalStake: number;
  activeNodesCount: number;
  rewardsPerMinute: number;
  apr: number;
}

const fetchNetworkStats = async (): Promise<NetworkStatsData> => {
  // Fetch from the network_stats view
  const { data: networkStats, error: networkStatsError } = await supabase
    .from('network_stats')
    .select('*')
    .single();

  if (networkStatsError) throw networkStatsError;

  // Fetch the rewards per minute
  const { data: provisioners, error: provisionersError } = await supabase
    .from('provisioners')
    .select('rewards_last_minute');

  if (provisionersError) throw provisionersError;

  // Calculate total rewards per minute
  const rewardsPerMinute = provisioners.reduce((sum, node) => 
    sum + (node.rewards_last_minute || 0), 0);

  return {
    totalStake: networkStats?.total_network_stake || 0,
    activeNodesCount: networkStats?.active_nodes_count || 0,
    rewardsPerMinute,
    apr: networkStats?.apr_percentage || 0
  };
};

export function useNetworkStats() {
  return useQuery({
    queryKey: ['networkStats'],
    queryFn: fetchNetworkStats,
    refetchInterval: 60000, // Refresh every minute
    retry: 3,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
}
